module.exports = __webpack_public_path__ + "img/高通锐化75.b5183339.png";